import { FC } from 'react'
import { Roles } from '../modules/auth/roles'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { AccountStatusesBbaWrapper } from '../pages/accounts/accountStatusesBbaWrapper'
import { EditWrapperbba } from '../pages/legalInquiry/legalInquiryWrapperbba'
import { CodeBookWrapperBba } from '../pages/CodeBook/codeBookWrapperBba'
import { EditCodeBookWrapperBba } from '../pages/CodeBook/editCodeBookWrapperBba'

export type AppPage = {
  path: string
  component: FC
  menuTitle?: string
  canAccess: (roles: string[]) => boolean
}

// Korisnik samo s pravnom rolom ne dobija pretragu računa; ostali prijavljeni korisnici je imaju.
const canSearchAccounts = (roles: string[]) =>
  !roles.includes(Roles.Legal) || roles.includes(Roles.Bba)

const hasRole = (role: string) => (roles: string[]) => roles.includes(role)

// Jedino mjesto koje određuje rute, stavke menija i pristup stranicama.
export const appPages: AppPage[] = [
  {
    path: '/dashboard',
    component: DashboardWrapper,
    menuTitle: 'Pretraži račune',
    canAccess: canSearchAccounts,
  },
  {
    path: '/accountstatusesbba',
    component: AccountStatusesBbaWrapper,
    menuTitle: 'Pretraži statuse',
    canAccess: hasRole(Roles.Legal),
  },
  {
    path: '/legalinquiriesbba',
    component: EditWrapperbba,
    menuTitle: 'Pretraži izvode',
    canAccess: hasRole(Roles.Statements),
  },
  {
    path: '/CodeBookBba',
    component: CodeBookWrapperBba,
    menuTitle: 'Uredi šifarnik',
    canAccess: hasRole(Roles.CodeBook),
  },
  {
    path: '/editCodeBookBba',
    component: EditCodeBookWrapperBba,
    canAccess: hasRole(Roles.CodeBook),
  },
]

export const homePath = (roles: string[]) =>
  canSearchAccounts(roles) ? '/dashboard' : '/accountstatusesbba'
